import React, { FC, useState } from 'react';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { accordionDataHooks as dataHooks } from './Accordion.dataHooks';
import s from './Accordion.scss';
import { LinkWithQuery } from '../common/LinkWithQuery/LinkWithQuery';

export type Props = {
  onSubitemClick: (bucket: string) => void;
  onItemClick: (slug: string) => void;
  data: {
    title: string;
    content: {
      label: string;
      url: string;
      active?: boolean;
    }[];
  }[];
};

export const Accordion: FC<Props> = ({ data, onSubitemClick, onItemClick }) => {
  const openByDefault =
    data.find((bucket) => bucket.content.some((item) => item.active))?.title ||
    data[0].title;
  const [value, setValue] = useState<string | undefined>(openByDefault);

  return (
    <div className={s.Accordion} data-hook={dataHooks.container()}>
      {data.map(({ title, content }) => (
        <div
          key={title}
          data-hook={dataHooks.item({ key: title })}
          className={classNames(s.Accordion__item, {
            [s.Accordion__item_active]: value === title,
          })}
        >
          <div
            className={s.Accordion__itemTitle}
            onClick={() => {
              onItemClick(title);
              setValue(value === title ? undefined : title);
            }}
          >
            <span>{title}</span>
            <ChevronDown style={{ margin: '-4px 0' }} />
          </div>
          <div
            className={s.Accordion__itemContent}
            // passing items count to css here
            // to create proper expand/collapse animation
            style={{ '--items-count': content.length } as React.CSSProperties}
          >
            <ul className={s.Accordion__subItemsList}>
              {content.map(({ label, url, active }) => (
                <li key={label}>
                  <LinkWithQuery
                    data-hook={dataHooks.subitem({ key: label })}
                    to={url}
                    onClick={() => onSubitemClick(label)}
                    className={classNames({ [s.activeLink]: active })}
                  >
                    {label}
                  </LinkWithQuery>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};
